var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _g, _g2, _rect10, _path4, _rect11, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBranchTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 90,
    viewBox: "0 0 206 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2024_4316)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#137FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 14.5C65.0994 14.5 65.1948 14.5395 65.2651 14.6098C65.3355 14.6802 65.375 14.7755 65.375 14.875V17H66.4975C66.7627 17 67.017 17.1054 67.2046 17.2929C67.3921 17.4804 67.4975 17.7348 67.4975 18V20.2215L68.11 19.61C68.1446 19.5742 68.186 19.5457 68.2318 19.5261C68.2776 19.5066 68.3268 19.4963 68.3766 19.4959C68.4264 19.4956 68.4758 19.5051 68.5218 19.524C68.5679 19.543 68.6097 19.5709 68.6449 19.6061C68.68 19.6414 68.7078 19.6833 68.7266 19.7294C68.7454 19.7755 68.7548 19.8249 68.7543 19.8747C68.7538 19.9245 68.7434 19.9737 68.7237 20.0194C68.704 20.0651 68.6753 20.1065 68.6395 20.141L67.3875 21.391C67.3171 21.4612 67.2217 21.5005 67.1224 21.5004C67.023 21.5003 66.9277 21.4608 66.8575 21.3905L65.6075 20.1405C65.5706 20.1062 65.5411 20.0648 65.5206 20.0188C65.5001 19.9728 65.4891 19.9231 65.4882 19.8728C65.4873 19.8224 65.4965 19.7724 65.5154 19.7257C65.5343 19.679 65.5623 19.6366 65.598 19.601C65.6336 19.5654 65.676 19.5373 65.7227 19.5184C65.7694 19.4996 65.8194 19.4903 65.8697 19.4912C65.9201 19.4921 65.9697 19.5031 66.0157 19.5236C66.0617 19.5441 66.1031 19.5737 66.1375 19.6105L66.7475 20.22V18C66.7475 17.9337 66.7211 17.8701 66.6742 17.8232C66.6274 17.7763 66.5638 17.75 66.4975 17.75H63.4995C63.4332 17.75 63.3696 17.7763 63.3227 17.8232C63.2758 17.8701 63.2495 17.9337 63.2495 18V20.22L63.8595 19.6105C63.9306 19.5443 64.0246 19.5082 64.1217 19.5099C64.2189 19.5116 64.3116 19.551 64.3803 19.6197C64.449 19.6884 64.4883 19.7811 64.4901 19.8782C64.4918 19.9754 64.4557 20.0694 64.3895 20.1405L63.1395 21.3905C63.0692 21.4607 62.9738 21.5002 62.8745 21.5002C62.7751 21.5002 62.6798 21.4607 62.6095 21.3905L61.3595 20.1405C61.3237 20.1059 61.2951 20.0645 61.2755 20.0187C61.2559 19.973 61.2455 19.9238 61.2451 19.874C61.2447 19.8242 61.2542 19.7748 61.2731 19.7287C61.292 19.6827 61.3199 19.6408 61.3551 19.6056C61.3903 19.5704 61.4322 19.5426 61.4783 19.5237C61.5244 19.5049 61.5738 19.4955 61.6236 19.4959C61.6733 19.4964 61.7225 19.5067 61.7683 19.5264C61.814 19.5461 61.8554 19.5747 61.89 19.6105L62.5 20.22V18C62.5 17.7348 62.6053 17.4804 62.7929 17.2929C62.9804 17.1054 63.2348 17 63.5 17H64.625V14.875C64.625 14.7755 64.6645 14.6802 64.7348 14.6098C64.8051 14.5395 64.9005 14.5 65 14.5Z",
    fill: "#EEF9FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_2024_4316)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63,
    width: 85,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 69,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 73,
    width: 55,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_2024_4316)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 63,
    width: 85,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 69,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 73,
    width: 55,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2652 63.2652C45.1187 63.4116 44.8813 63.4116 44.7348 63.2652L42.3484 60.8787C42.2019 60.7322 42.2019 60.4948 42.3484 60.3483C42.4948 60.2019 42.7322 60.2019 42.8787 60.3483L45 62.4697L47.1213 60.3483C47.2678 60.2019 47.5052 60.2019 47.6516 60.3483C47.7981 60.4948 47.7981 60.7322 47.6516 60.8787L45.2652 63.2652ZM103.375 30V31.3387H102.625V30H103.375ZM103.375 32.2312V34.9086H102.625V32.2312H103.375ZM103.375 35.8011V38.4786H102.625V35.8011H103.375ZM103.375 39.3711V40.7098H102.625V39.3711H103.375ZM103.375 40.7098C103.375 41.151 103.31 41.5776 103.188 41.98L102.47 41.7626C102.571 41.4298 102.625 41.0765 102.625 40.7098H103.375ZM102.859 42.7728C102.451 43.5343 101.825 44.1608 101.063 44.5687L100.709 43.9076C101.34 43.5695 101.86 43.0498 102.198 42.4186L102.859 42.7728ZM100.27 44.8974C99.8678 45.0193 99.4412 45.0848 99 45.0848V44.3348C99.3667 44.3348 99.7201 44.2804 100.053 44.1796L100.27 44.8974ZM99 45.0848H97.5577V44.3348H99V45.0848ZM96.5962 45.0848H93.7115V44.3348H96.5962V45.0848ZM92.75 45.0848H89.8654V44.3348H92.75V45.0848ZM88.9038 45.0848H86.0192V44.3348H88.9038V45.0848ZM85.0577 45.0848H82.1731V44.3348H85.0577V45.0848ZM81.2115 45.0848H78.3269V44.3348H81.2115V45.0848ZM77.3654 45.0848H74.4808V44.3348H77.3654V45.0848ZM73.5192 45.0848H70.6346V44.3348H73.5192V45.0848ZM69.6731 45.0848H66.7885V44.3348H69.6731V45.0848ZM65.8269 45.0848H62.9423V44.3348H65.8269V45.0848ZM61.9808 45.0848H59.0961V44.3348H61.9808V45.0848ZM58.1346 45.0848H55.25V44.3348H58.1346V45.0848ZM54.2885 45.0848H51.4038V44.3348H54.2885V45.0848ZM50.4423 45.0848H49V44.3348H50.4423V45.0848ZM49 45.0848C48.6333 45.0848 48.2799 45.1391 47.9472 45.2399L47.7297 44.5221C48.1322 44.4002 48.5588 44.3348 49 44.3348V45.0848ZM47.2911 45.5119C46.66 45.85 46.1402 46.3697 45.8022 47.0009L45.141 46.6468C45.5489 45.8852 46.1755 45.2587 46.937 44.8508L47.2911 45.5119ZM45.5301 47.657C45.4293 47.9897 45.375 48.3431 45.375 48.7098H44.625C44.625 48.2686 44.6904 47.842 44.8124 47.4395L45.5301 47.657ZM45.375 48.7098V50.0495H44.625V48.7098H45.375ZM45.375 50.9426V53.622H44.625V50.9426H45.375ZM45.375 54.5152V57.1946H44.625V54.5152H45.375ZM45.375 58.0877V60.7672H44.625V58.0877H45.375ZM45.375 61.6603V63H44.625V61.6603H45.375Z",
    fill: "#3DC3C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.735 63.2652C160.881 63.4116 161.119 63.4116 161.265 63.2652L163.652 60.8787C163.798 60.7322 163.798 60.4948 163.652 60.3483C163.505 60.2019 163.268 60.2019 163.121 60.3483L161 62.4697L158.879 60.3483C158.732 60.2019 158.495 60.2019 158.348 60.3483C158.202 60.4948 158.202 60.7322 158.348 60.8787L160.735 63.2652ZM102.625 30V31.3387H103.375V30H102.625ZM102.625 32.2312V34.9086H103.375V32.2312H102.625ZM102.625 35.8011V38.4786H103.375V35.8011H102.625ZM102.625 39.3711V40.7098H103.375V39.3711H102.625ZM102.625 40.7098C102.625 41.151 102.69 41.5776 102.812 41.98L103.53 41.7626C103.429 41.4298 103.375 41.0765 103.375 40.7098H102.625ZM103.141 42.7728C103.549 43.5343 104.175 44.1608 104.937 44.5687L105.291 43.9076C104.66 43.5695 104.14 43.0498 103.802 42.4186L103.141 42.7728ZM105.73 44.8974C106.132 45.0193 106.559 45.0848 107 45.0848V44.3348C106.633 44.3348 106.28 44.2804 105.947 44.1796L105.73 44.8974ZM107 45.0848H108.442V44.3348H107V45.0848ZM109.404 45.0848H112.288V44.3348H109.404V45.0848ZM113.25 45.0848H116.135V44.3348H113.25V45.0848ZM117.096 45.0848H119.981V44.3348H117.096V45.0848ZM120.942 45.0848H123.827V44.3348H120.942V45.0848ZM124.788 45.0848H127.673V44.3348H124.788V45.0848ZM128.635 45.0848H131.519V44.3348H128.635V45.0848ZM132.481 45.0848H135.365V44.3348H132.481V45.0848ZM136.327 45.0848H139.212V44.3348H136.327V45.0848ZM140.173 45.0848H143.058V44.3348H140.173V45.0848ZM144.019 45.0848H146.904V44.3348H144.019V45.0848ZM147.865 45.0848H150.75V44.3348H147.865V45.0848ZM151.712 45.0848H154.596V44.3348H151.712V45.0848ZM155.558 45.0848H157V44.3348H155.558V45.0848ZM157 45.0848C157.367 45.0848 157.72 45.1391 158.053 45.2399L158.27 44.5221C157.868 44.4002 157.441 44.3348 157 44.3348V45.0848ZM158.709 45.5119C159.34 45.85 159.86 46.3697 160.198 47.0009L160.859 46.6468C160.451 45.8852 159.825 45.2587 159.063 44.8508L158.709 45.5119ZM160.47 47.657C160.571 47.9897 160.625 48.3431 160.625 48.7098H161.375C161.375 48.2686 161.31 47.842 161.188 47.4395L160.47 47.657ZM160.625 48.7098V50.0495H161.375V48.7098H160.625ZM160.625 50.9426V53.622H161.375V50.9426H160.625ZM160.625 54.5152V57.1946H161.375V54.5152H160.625ZM160.625 58.0877V60.7672H161.375V58.0877H160.625ZM160.625 61.6603V63H161.375V61.6603H160.625Z",
    fill: "#4276EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2024_4316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.735 63.2652C160.881 63.4116 161.119 63.4116 161.265 63.2652L163.652 60.8787C163.798 60.7322 163.798 60.4948 163.652 60.3483C163.505 60.2019 163.268 60.2019 163.121 60.3483L161 62.4697L158.879 60.3483C158.732 60.2019 158.495 60.2019 158.348 60.3483C158.202 60.4948 158.202 60.7322 158.348 60.8787L160.735 63.2652ZM102.625 30V31.3387H103.375V30H102.625ZM102.625 32.2312V34.9086H103.375V32.2312H102.625ZM102.625 35.8011V38.4786H103.375V35.8011H102.625ZM102.625 39.3711V40.7098H103.375V39.3711H102.625ZM102.625 40.7098C102.625 41.151 102.69 41.5776 102.812 41.98L103.53 41.7626C103.429 41.4298 103.375 41.0765 103.375 40.7098H102.625ZM103.141 42.7728C103.549 43.5343 104.175 44.1608 104.937 44.5687L105.291 43.9076C104.66 43.5695 104.14 43.0498 103.802 42.4186L103.141 42.7728ZM105.73 44.8974C106.132 45.0193 106.559 45.0848 107 45.0848V44.3348C106.633 44.3348 106.28 44.2804 105.947 44.1796L105.73 44.8974ZM107 45.0848H108.442V44.3348H107V45.0848ZM109.404 45.0848H112.288V44.3348H109.404V45.0848ZM113.25 45.0848H116.135V44.3348H113.25V45.0848ZM117.096 45.0848H119.981V44.3348H117.096V45.0848ZM120.942 45.0848H123.827V44.3348H120.942V45.0848ZM124.788 45.0848H127.673V44.3348H124.788V45.0848ZM128.635 45.0848H131.519V44.3348H128.635V45.0848ZM132.481 45.0848H135.365V44.3348H132.481V45.0848ZM136.327 45.0848H139.212V44.3348H136.327V45.0848ZM140.173 45.0848H143.058V44.3348H140.173V45.0848ZM144.019 45.0848H146.904V44.3348H144.019V45.0848ZM147.865 45.0848H150.75V44.3348H147.865V45.0848ZM151.712 45.0848H154.596V44.3348H151.712V45.0848ZM155.558 45.0848H157V44.3348H155.558V45.0848ZM157 45.0848C157.367 45.0848 157.72 45.1391 158.053 45.2399L158.27 44.5221C157.868 44.4002 157.441 44.3348 157 44.3348V45.0848ZM158.709 45.5119C159.34 45.85 159.86 46.3697 160.198 47.0009L160.859 46.6468C160.451 45.8852 159.825 45.2587 159.063 44.8508L158.709 45.5119ZM160.47 47.657C160.571 47.9897 160.625 48.3431 160.625 48.7098H161.375C161.375 48.2686 161.31 47.842 161.188 47.4395L160.47 47.657ZM160.625 48.7098V50.0495H161.375V48.7098H160.625ZM160.625 50.9426V53.622H161.375V50.9426H160.625ZM160.625 54.5152V57.1946H161.375V54.5152H160.625ZM160.625 58.0877V60.7672H161.375V58.0877H160.625ZM160.625 61.6603V63H161.375V61.6603H160.625Z",
    fill: "#7DA0FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2024_4316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2652 63.2652C45.1187 63.4116 44.8813 63.4116 44.7348 63.2652L42.3484 60.8787C42.2019 60.7322 42.2019 60.4948 42.3484 60.3483C42.4948 60.2019 42.7322 60.2019 42.8787 60.3483L45 62.4697L47.1213 60.3483C47.2678 60.2019 47.5052 60.2019 47.6516 60.3483C47.7981 60.4948 47.7981 60.7322 47.6516 60.8787L45.2652 63.2652ZM103.375 30V31.3387H102.625V30H103.375ZM103.375 32.2312V34.9086H102.625V32.2312H103.375ZM103.375 35.8011V38.4786H102.625V35.8011H103.375ZM103.375 39.3711V40.7098H102.625V39.3711H103.375ZM103.375 40.7098C103.375 41.151 103.31 41.5776 103.188 41.98L102.47 41.7626C102.571 41.4298 102.625 41.0765 102.625 40.7098H103.375ZM102.859 42.7728C102.451 43.5343 101.825 44.1608 101.063 44.5687L100.709 43.9076C101.34 43.5695 101.86 43.0498 102.198 42.4186L102.859 42.7728ZM100.27 44.8974C99.8678 45.0193 99.4412 45.0848 99 45.0848V44.3348C99.3667 44.3348 99.7201 44.2804 100.053 44.1796L100.27 44.8974ZM99 45.0848H97.5577V44.3348H99V45.0848ZM96.5962 45.0848H93.7115V44.3348H96.5962V45.0848ZM92.75 45.0848H89.8654V44.3348H92.75V45.0848ZM88.9038 45.0848H86.0192V44.3348H88.9038V45.0848ZM85.0577 45.0848H82.1731V44.3348H85.0577V45.0848ZM81.2115 45.0848H78.3269V44.3348H81.2115V45.0848ZM77.3654 45.0848H74.4808V44.3348H77.3654V45.0848ZM73.5192 45.0848H70.6346V44.3348H73.5192V45.0848ZM69.6731 45.0848H66.7885V44.3348H69.6731V45.0848ZM65.8269 45.0848H62.9423V44.3348H65.8269V45.0848ZM61.9808 45.0848H59.0961V44.3348H61.9808V45.0848ZM58.1346 45.0848H55.25V44.3348H58.1346V45.0848ZM54.2885 45.0848H51.4038V44.3348H54.2885V45.0848ZM50.4423 45.0848H49V44.3348H50.4423V45.0848ZM49 45.0848C48.6333 45.0848 48.2799 45.1391 47.9472 45.2399L47.7297 44.5221C48.1322 44.4002 48.5588 44.3348 49 44.3348V45.0848ZM47.2911 45.5119C46.66 45.85 46.1402 46.3697 45.8022 47.0009L45.141 46.6468C45.5489 45.8852 46.1755 45.2587 46.937 44.8508L47.2911 45.5119ZM45.5301 47.657C45.4293 47.9897 45.375 48.3431 45.375 48.7098H44.625C44.625 48.2686 44.6904 47.842 44.8124 47.4395L45.5301 47.657ZM45.375 48.7098V50.0495H44.625V48.7098H45.375ZM45.375 50.9426V53.622H44.625V50.9426H45.375ZM45.375 54.5152V57.1946H44.625V54.5152H45.375ZM45.375 58.0877V60.7672H44.625V58.0877H45.375ZM45.375 61.6603V63H44.625V61.6603H45.375Z",
    fill: "#24A5A8"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    transform: "translate(66 38)",
    fill: "#1F2C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4418 40.2727V49H70.8608V40.2727H72.4418ZM77.4009 42.4545V43.6477H73.5316V42.4545H77.4009ZM74.4989 49V41.8366C74.4989 41.3963 74.5898 41.0298 74.7717 40.7372C74.9563 40.4446 75.2035 40.2259 75.5131 40.081C75.8228 39.9361 76.1665 39.8636 76.5444 39.8636C76.8114 39.8636 77.0487 39.8849 77.256 39.9276C77.4634 39.9702 77.6168 40.0085 77.7163 40.0426L77.4094 41.2358C77.3441 41.2159 77.2617 41.196 77.1623 41.1761C77.0629 41.1534 76.9521 41.142 76.8299 41.142C76.543 41.142 76.3398 41.2116 76.2205 41.3509C76.104 41.4872 76.0458 41.6832 76.0458 41.9389V49H74.4989Z",
    fill: "#D6E6FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 14,
    transform: "translate(115.5 38)",
    fill: "#1F2C3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.361 49V40.2727H126.037V41.598H121.942V43.9673H125.743V45.2926H121.942V47.6747H126.071V49H120.361ZM129.124 40.2727V49H127.582V40.2727H129.124ZM135.884 44.1847L134.478 44.3381C134.438 44.196 134.368 44.0625 134.269 43.9375C134.172 43.8125 134.042 43.7116 133.877 43.6349C133.712 43.5582 133.51 43.5199 133.272 43.5199C132.951 43.5199 132.681 43.5895 132.462 43.7287C132.246 43.8679 132.14 44.0483 132.142 44.2699C132.14 44.4602 132.209 44.6151 132.351 44.7344C132.496 44.8537 132.735 44.9517 133.067 45.0284L134.184 45.267C134.803 45.4006 135.263 45.6122 135.564 45.902C135.868 46.1918 136.022 46.571 136.025 47.0398C136.022 47.4517 135.901 47.8153 135.662 48.1307C135.426 48.4432 135.098 48.6875 134.678 48.8636C134.257 49.0398 133.775 49.1278 133.229 49.1278C132.428 49.1278 131.783 48.9602 131.294 48.625C130.806 48.2869 130.515 47.8168 130.421 47.2145L131.925 47.0696C131.993 47.3651 132.138 47.5881 132.36 47.7386C132.581 47.8892 132.87 47.9645 133.225 47.9645C133.591 47.9645 133.885 47.8892 134.107 47.7386C134.331 47.5881 134.444 47.402 134.444 47.1804C134.444 46.9929 134.371 46.8381 134.226 46.7159C134.084 46.5937 133.863 46.5 133.561 46.4347L132.445 46.2003C131.817 46.0696 131.353 45.8494 131.051 45.5398C130.75 45.2273 130.601 44.8324 130.604 44.3551C130.601 43.9517 130.711 43.6023 130.932 43.3068C131.157 43.0085 131.468 42.7784 131.865 42.6165C132.266 42.4517 132.728 42.3693 133.25 42.3693C134.017 42.3693 134.621 42.5327 135.061 42.8594C135.505 43.1861 135.779 43.6278 135.884 44.1847ZM140.194 49.1278C139.538 49.1278 138.971 48.9915 138.494 48.7188C138.02 48.4432 137.654 48.054 137.399 47.5511C137.143 47.0455 137.015 46.4503 137.015 45.7656C137.015 45.0923 137.143 44.5014 137.399 43.9929C137.657 43.4815 138.018 43.0838 138.481 42.7997C138.944 42.5128 139.488 42.3693 140.113 42.3693C140.517 42.3693 140.897 42.4347 141.255 42.5653C141.616 42.6932 141.934 42.892 142.21 43.1619C142.488 43.4318 142.707 43.7756 142.866 44.1932C143.025 44.608 143.105 45.1023 143.105 45.6761V46.1491H137.74V45.1094H141.626C141.623 44.8139 141.559 44.5511 141.434 44.321C141.309 44.0881 141.135 43.9048 140.91 43.7713C140.689 43.6378 140.43 43.571 140.135 43.571C139.819 43.571 139.542 43.6477 139.304 43.8011C139.065 43.9517 138.879 44.1506 138.745 44.3977C138.615 44.642 138.548 44.9105 138.545 45.2031V46.1108C138.545 46.4915 138.615 46.8182 138.754 47.0909C138.893 47.3608 139.088 47.5682 139.338 47.7131C139.588 47.8551 139.88 47.9261 140.216 47.9261C140.44 47.9261 140.643 47.8949 140.825 47.8324C141.007 47.767 141.164 47.6719 141.298 47.5469C141.431 47.4219 141.532 47.267 141.6 47.0824L143.041 47.2443C142.95 47.625 142.777 47.9574 142.521 48.2415C142.268 48.5227 141.944 48.7415 141.549 48.8977C141.154 49.0511 140.703 49.1278 140.194 49.1278Z",
    fill: "#D6E6FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2024_4316",
    x: 44,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2024_4316",
    result: "effect2_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2024_4316",
    result: "effect3_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2024_4316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_2024_4316",
    x: 0,
    y: 57,
    width: 103,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2024_4316",
    result: "effect2_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2024_4316",
    result: "effect3_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2024_4316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_2024_4316",
    x: 103,
    y: 57,
    width: 103,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2024_4316",
    result: "effect2_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2024_4316",
    result: "effect3_dropShadow_2024_4316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2024_4316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2024_4316",
    x: 90.625,
    y: 18,
    width: 85.1367,
    height: 57.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_2024_4316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2024_4316",
    x: 30.2383,
    y: 18,
    width: 85.1367,
    height: 57.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_2024_4316"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchTooltipIcon);
export default __webpack_public_path__ + "static/media/branchTooltipIcon.d48b3a3d8c72ef6cd9e94706a3a5bdad.svg";
export { ForwardRef as ReactComponent };